import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RoomStreamVO } from "@youm-front/room/domain";
import { buildRoomStreamVO } from "@youm-front/room/util/factory";
import {
  ROOM_REMOTE_STREAMS_FEATURE_KEY,
  roomRemoteStreamsAdapter,
  RoomRemoteStreamsState
} from "../reducers";

export const roomRemoteStreamsState =
  createFeatureSelector<RoomRemoteStreamsState>(
    ROOM_REMOTE_STREAMS_FEATURE_KEY
  );

const { selectAll } = roomRemoteStreamsAdapter.getSelectors();

export const roomRemoteStreams = createSelector(
  roomRemoteStreamsState,
  (state: RoomRemoteStreamsState) =>
    selectAll(state).map((_) => buildRoomStreamVO(_))
);
export const roomRemoteActiveStreams = createSelector(
  roomRemoteStreams,
  (roomRemoteStreams: RoomStreamVO[]) =>
    roomRemoteStreams.filter((_) => _.value.streamIsActive)
);
